import { Layout, Sparkles } from 'lucide-react';
import { useHARStore } from '@/stores/har-store';
import { cn } from '@/lib/utils';

export function ViewSwitcher() {
  const { har, viewMode, setViewMode } = useHARStore();

  if (!har) return null;

  return (
    <div className="flex items-center gap-1 px-1">
      <div className="flex bg-slate-100 dark:bg-slate-800 rounded-lg p-0.5">
        <button
          onClick={() => setViewMode('advanced')}
          className={cn(
            'px-2.5 py-1.5 text-xs font-medium rounded-md transition-colors flex items-center gap-1.5',
            viewMode === 'advanced'
              ? 'bg-white dark:bg-slate-700 text-slate-900 dark:text-slate-100 shadow-sm'
              : 'text-slate-500 hover:text-slate-700 dark:hover:text-slate-300'
          )}
          title="Advanced view with all analysis tools"
        >
          <Layout className="w-3.5 h-3.5" />
          <span className="hidden sm:inline">Advanced</span>
        </button>
        <button
          onClick={() => setViewMode('basic')}
          className={cn(
            'px-2.5 py-1.5 text-xs font-medium rounded-md transition-colors flex items-center gap-1.5',
            viewMode === 'basic'
              ? 'bg-white dark:bg-slate-700 text-slate-900 dark:text-slate-100 shadow-sm'
              : 'text-slate-500 hover:text-slate-700 dark:hover:text-slate-300'
          )}
          title="Basic view for quick health checks"
        >
          <Sparkles className="w-3.5 h-3.5" />
          <span className="hidden sm:inline">Basic</span>
        </button>
      </div>
    </div>
  );
}
